(function () {
  'use strict';

  /* ================================================================
     NewPharma — "Descubre el Mundo Fungi"

     Cinco hongos que se recorren con el scroll. La seccion mide
     `100svh + (escenas - 1) x alto_escena` y adentro hay un hijo
     `position: sticky`.

     EL SCROLL NO SE SECUESTRA. No hay `preventDefault` sobre la rueda
     ni `scrollTo` propio salvo cuando el cliente pulsa un circulo de la
     linea de tiempo. El navegador scrollea como siempre y este archivo
     solo LEE cuanto se avanzo; al terminar la quinta escena el sticky
     se despega solo y la pagina sigue.

     TODO SE DERIVA DE LA POSICION DEL SCROLL, no de temporizadores.
     Por eso el recorrido es reversible y determinista: volver a una
     posicion anterior muestra exactamente el hongo que corresponde, sin
     importar como se haya llegado ahi.

     EN MOVIL TAMBIEN MANDA EL SCROLL, desde el 24 de octubre. Estuvo
     sin sticky, apoyandose en que el brief permitia "una alternativa en
     pantallas pequenas", pero eso dejaba el cambio de lente fuera del
     telefono y la clienta lo reporto dos veces. Ahora los dos tamanos
     se comportan igual, como en "Encuentra el formato perfecto".

     `saltar()` queda para el respaldo sin progreso que leer.

     SIN ESTE ARCHIVO la seccion sigue siendo legible: las cinco fichas
     estan en el HTML con su nombre, su descripcion y su enlace. La
     clase `np-fungi--js` es la que activa el apilado.
     ================================================================ */

  var ESCRITORIO = '(min-width: 990px)';

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  /* Mantiene la escena quieta en los extremos y concentra el cambio en
     el medio del tramo: da tiempo a leer antes y despues de la
     transicion, en vez de que el texto este siempre a medio camino.

     EL REPOSO SE ENSANCHO el 24 de octubre. Antes la transicion ocupaba
     del 22% al 78% del tramo —o sea el 56% del recorrido— y al soltar el
     scroll en cualquier punto habia mas de una chance entre dos de
     quedar a mitad de camino, con la foto desenfocada y la columna de
     texto cruzandose. Ahora va del 28% al 74%: mas de la mitad del
     recorrido es una escena ASENTADA. */
  function tramo(t) {
    var u = clamp((t - 0.28) / 0.46, 0, 1);
    return u * u * (3 - 2 * u);              // smoothstep
  }

  function arrancar(raiz) {
    if (raiz.dataset.npFungiActivo) return;
    raiz.dataset.npFungiActivo = '1';

    var n = parseInt(raiz.getAttribute('data-escenas'), 10) || 0;
    if (n < 1) return;

    var fotos  = [].slice.call(raiz.querySelectorAll('.np-fungi__foto'));
    var tags   = [].slice.call(raiz.querySelectorAll('.np-fungi__tag'));
    var pines  = [].slice.call(raiz.querySelectorAll('[data-np-fungi-pin]'));
    var fichas = [].slice.call(raiz.querySelectorAll('.np-fungi__panel'));
    var relleno = raiz.querySelector('[data-np-fungi-fill]');
    var vinieta = raiz.querySelector('[data-np-fungi-vinieta]');
    var lente = raiz.querySelector('[data-np-fungi-lente]');
    var swap   = raiz.querySelector('[data-np-fungi-swap]');

    var mqEsc = window.matchMedia(ESCRITORIO);
    var mqRed = window.matchMedia('(prefers-reduced-motion: reduce)');
    var reduce = mqRed.matches;

    var actual = -1;
    var pendiente = false;
    var ultimoPintado = 0;

    raiz.classList.add('np-fungi--js');

    /* ----------------------------------------------------------------
       EL ALTO DE LA COLUMNA DE TEXTO SE RESERVA A MANO.

       Las cinco fichas van absolutas y superpuestas: sin esto el
       contenedor mediria cero y los botones se saldrian. Se mide la mas
       alta con todas visibles por un instante y se fija ese valor, asi
       el bloque NO cambia de altura al pasar de un hongo a otro —que es
       lo que pide el brief—.

       Se vuelve a medir al cambiar el ancho, porque el texto reparte
       distinto y la mas alta puede ser otra.
       ---------------------------------------------------------------- */
    function medir() {
      if (!swap) return;
      swap.style.height = 'auto';
      var alto = 0;
      fichas.forEach(function (f) {
        var antes = f.style.cssText;
        f.style.cssText = antes + ';position:static;opacity:1;visibility:visible;transform:none;';
        alto = Math.max(alto, f.offsetHeight);
        f.style.cssText = antes;
      });
      if (alto) swap.style.height = alto + 'px';
    }

    /* ----------------------------------------------------------------
       EL CAMBIO DE LENTE.

       `i` es la muestra que sale, `v` la que entra y `u` va de 0 a 1.

       NO ES UN FUNDIDO NI UNA MASCARA QUE SE ABRE. La version anterior
       revelaba la foto nueva con un `clip-path: circle()` que crecia;
       la clienta pidio el 24 de octubre que se sienta como cambiar el
       objetivo de un microscopio, asi que el recorte dejo de animarse
       —el circulo es ESTABLE, lo recorta el contenedor— y lo que cambia
       es el ESTADO OPTICO de la imagen:

         la que sale   enfocada -> desenfocada, se aleja y se aclara
         la que entra  desenfocada y grande -> nitida y asentada

       Las dos se superponen un rato a proposito: ese solape es lo que
       lee el ojo como "el lente se reajusto", en vez de como dos fotos
       intercambiadas.

       POR QUE EL DESENFOQUE DE ENTRADA TERMINA EN u=0,88 Y NO EN 1: el
       ultimo tramo sin blur es el "asentarse" del enfoque. Si llegara
       nitida justo al final del recorrido, la escena se sentiria
       cortada en seco.

       El ANILLO VERDE no se toca en ningun momento.
       ---------------------------------------------------------------- */
    function pintarPar(i, v, u) {
      for (var k = 0; k < fotos.length; k++) {
        var f = fotos[k];

        if (k !== i && k !== v) {
          if (f.style.opacity !== '0') {
            f.style.opacity = '0';
            f.style.filter = '';
            f.style.transform = '';
          }
          continue;
        }

        /* Con "reducir movimiento" no hay optica: cambio simple. El
           desenfoque y el zoom son justo lo que ese ajuste pide
           evitar. */
        if (reduce) {
          f.style.filter = '';
          f.style.transform = '';
          f.style.opacity = (k === (u < 0.5 ? i : v)) ? '1' : '0';
          continue;
        }

        if (k === i) {
          // Sale de foco mientras se aleja y pierde contraste, como
          // una muestra que se abandona.
          var d = clamp(u / 0.62, 0, 1);
          f.style.opacity = String(clamp(1 - (u - 0.3) / 0.34, 0, 1));
          f.style.filter = 'blur(' + (10 * d).toFixed(2) + 'px) brightness(' + (1 + 0.1 * d).toFixed(3) + ') contrast(' + (1 - 0.14 * d).toFixed(3) + ')';
          f.style.transform = 'translate3d(0,' + (-6 * d).toFixed(2) + 'px,0) scale(' + (1 + 0.055 * d).toFixed(4) + ')';
        } else {
          // Entra fuera de foco y se va enfocando. `e` llega a 1 antes
          // que `u` para dejar ese respiro final ya nitido.
          var e = clamp((u - 0.26) / 0.62, 0, 1);
          f.style.opacity = String(clamp((u - 0.28) / 0.3, 0, 1));
          f.style.filter = 'blur(' + (13 * (1 - e)).toFixed(2) + 'px) brightness(' + (1 + 0.12 * (1 - e)).toFixed(3) + ') contrast(' + (1 - 0.16 * (1 - e)).toFixed(3) + ')';
          f.style.transform = 'translate3d(0,' + (5 * (1 - e)).toFixed(2) + 'px,0) scale(' + (1.05 - 0.05 * e).toFixed(4) + ')';
        }
      }

      /* El halo del visor acompana: sube en el medio del cambio y se
         apaga en los extremos, asi que en reposo no se ve. */
      if (vinieta) {
        vinieta.style.opacity = reduce ? '0' : (Math.sin(clamp(u, 0, 1) * Math.PI) * 0.38).toFixed(3);
      }

      /* ------------------------------------------------------------
         EL OBJETIVO QUE ENTRA.

         Llega desde arriba a la derecha, se posa sobre la vista y se
         desvanece al asentarse. El recorrido no es lineal: `llegada`
         frena cerca del final (ease-out) para que el disco se POSE en
         vez de chocar, y la opacidad entra y sale por separado.

         ARRANCA CASI TRANSPARENTE a proposito. En su punto mas lejano
         el disco se sale de la columna de la foto y pasa por encima de
         la linea de tiempo; con la opacidad todavia cerca de cero ese
         cruce no se nota.

         Se asienta en u=0,72 y de ahi al final solo se apaga: el ultimo
         tramo es el vidrio desapareciendo, no el disco moviendose.
         ------------------------------------------------------------ */
      if (lente) {
        if (reduce) {
          lente.style.opacity = '0';
        } else {
          var t = clamp(u / 0.72, 0, 1);
          var llegada = 1 - Math.pow(1 - t, 3);
          var entra = clamp(u / 0.22, 0, 1);
          var apaga = clamp((u - 0.74) / 0.26, 0, 1);
          lente.style.opacity = (entra * (1 - apaga) * 0.92).toFixed(3);
          lente.style.transform =
            'translate3d(' + (42 * (1 - llegada)).toFixed(2) + '%,' +
            (-38 * (1 - llegada)).toFixed(2) + '%,0) scale(' +
            (0.58 + 0.42 * llegada).toFixed(4) + ')';
        }
      }
    }

    /* El texto y la pastilla se pasan la posta EXACTAMENTE a mitad de
       camino: el que sale llega a cero justo cuando el que entra
       arranca. Ni se superponen —se leerian dos nombres a la vez— ni
       dejan hueco.

       La primera version apagaba al saliente en u=0,42 y encendia al
       entrante en u=0,58: ese 16% del tramo quedaba con la columna en
       blanco, y bajando despacio se veia el vacio. */
    function pintarTexto(i, v, u) {
      var sale = clamp(1 - u / 0.5, 0, 1);
      var entra = clamp((u - 0.5) / 0.5, 0, 1);
      function aplicar(lista, desplaza) {
        for (var k = 0; k < lista.length; k++) {
          var el = lista[k], o = 0, y = 0;
          if (k === i) { o = sale; y = -(1 - sale) * desplaza; }
          else if (k === v) { o = entra; y = (1 - entra) * desplaza; }
          el.style.opacity = String(o);
          el.style.transform = reduce ? '' : 'translate3d(0,' + y.toFixed(2) + 'px,0)';
          el.style.visibility = o > 0.01 ? 'visible' : 'hidden';
        }
      }
      aplicar(fichas, 14);
      aplicar(tags, 10);
    }

    function marcarActivo(idx) {
      if (idx === actual) return;
      actual = idx;
      for (var k = 0; k < pines.length; k++) {
        var on = k === idx;
        pines[k].classList.toggle('is-activo', on);
        pines[k].setAttribute('aria-selected', on ? 'true' : 'false');
        pines[k].tabIndex = on ? 0 : -1;
      }
      for (var j = 0; j < fichas.length; j++) {
        var act = j === idx;
        fichas[j].classList.toggle('is-activo', act);
        // `aria-hidden` sobre la que no se ve: sin esto un lector de
        // pantalla leeria los cinco hongos de corrido.
        if (act) fichas[j].removeAttribute('aria-hidden');
        else fichas[j].setAttribute('aria-hidden', 'true');
      }
      for (var m = 0; m < tags.length; m++) tags[m].classList.toggle('is-activo', m === idx);
      raiz.setAttribute('data-escena-activa', String(idx));
    }

    /* Progreso 0..1 a lo largo de la seccion. Arranca cuando el borde
       superior llega a 0 y termina cuando quedan 100vh por recorrer,
       que es justo el alto del sticky. */
    function progreso() {
      var r = raiz.getBoundingClientRect();
      var recorrido = r.height - window.innerHeight;
      if (recorrido <= 0) return 0;
      return clamp(-r.top / recorrido, 0, 1);
    }

    function pintar() {
      pendiente = false;
      ultimoPintado = Date.now();

      var p = progreso();
      var exacto = p * (n - 1);
      var i = Math.floor(clamp(exacto, 0, n - 1.0001));
      var v = Math.min(i + 1, n - 1);
      var u = tramo(clamp(exacto - i, 0, 1));

      pintarPar(i, v, u);
      pintarTexto(i, v, u);
      marcarActivo(u < 0.5 ? i : v);
      if (relleno) relleno.style.height = (p * 100).toFixed(2) + '%';
    }

    /* EL FLAG `pendiente` PUEDE QUEDARSE TRABADO. Si el cuadro que se
       pidio no llega —pestana en segundo plano, ventana tapada, el
       navegador sin componer— el flag se queda en `true` y TODOS los
       scrolls siguientes se descartan: la seccion se congela. Con el
       sello de tiempo, si pasaron mas de 150 ms sin pintar se vuelve a
       pedir el cuadro en vez de seguir esperando al que no vino. */
    function alScroll() {
      if (!enPantalla) return;
      if (pendiente && (Date.now() - ultimoPintado) < 150) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }

    /* ----------------------------------------------------------------
       IR A UN HONGO MOVIENDO EL SCROLL, no solo cambiando clases.

       Es lo unico coherente con que la escena la decida la posicion: si
       un clic cambiara la ficha sin mover la pagina, al mover la rueda
       un pixel volveria de golpe a la que corresponde por posicion. Se
       apunta al centro del tramo para no quedar en el filo, y el
       desplazamiento suave reproduce la misma transicion sin tener que
       recorrer los estados intermedios a mano.
       ---------------------------------------------------------------- */
    function irA(idx) {
      idx = clamp(idx, 0, n - 1);
      var r = raiz.getBoundingClientRect();
      var top = r.top + window.pageYOffset;
      var recorrido = r.height - window.innerHeight;
      window.scrollTo({
        top: top + recorrido * (idx / (n - 1)),
        behavior: reduce ? 'auto' : 'smooth'
      });
    }

    /* ----------------------------------------------------------------
       EN MOVIL NO HAY PROGRESO QUE LEER, pero si hay cambio de lente.

       En escritorio la transicion la dibuja el scroll: `u` sale de la
       posicion de la pagina. En un telefono no hay sticky —la seccion
       mide lo que mide— asi que el mismo recorrido se anima POR TIEMPO
       con un `requestAnimationFrame`, reusando `pintarPar` y
       `pintarTexto`. El efecto es identico; lo unico distinto es de
       donde sale la `u`.

       Se escribio asi el 24 de octubre: hasta entonces el movil hacia
       un cambio seco de opacidad y se perdia todo el efecto.

       `animacion` guarda el cuadro pendiente: si el cliente toca otro
       hongo a mitad de camino, se corta el anterior en vez de dejar
       dos recorridos peleandose por las mismas fotos.
       ---------------------------------------------------------------- */
    var animacion = null;
    var DURACION = 820;

    function fijar(idx) {
      for (var k = 0; k < fotos.length; k++) {
        fotos[k].style.filter = '';
        fotos[k].style.transform = '';
        fotos[k].style.opacity = k === idx ? '1' : '0';
      }
      if (vinieta) vinieta.style.opacity = '0';
      if (lente) { lente.style.opacity = '0'; lente.style.transform = ''; }
      [fichas, tags].forEach(function (lista) {
        for (var k = 0; k < lista.length; k++) {
          var on = k === idx;
          lista[k].style.opacity = on ? '1' : '0';
          lista[k].style.transform = '';
          lista[k].style.visibility = on ? 'visible' : 'hidden';
        }
      });
      marcarActivo(idx);
      if (relleno) relleno.style.height = (n > 1 ? (idx / (n - 1)) * 100 : 100).toFixed(2) + '%';
    }

    function saltar(idx, animado) {
      idx = clamp(idx, 0, n - 1);
      if (animacion) { cancelAnimationFrame(animacion); animacion = null; }

      var desde = actual;
      if (!animado || reduce || desde < 0 || desde === idx) { fijar(idx); return; }

      var t0 = 0;
      (function paso(ahora) {
        if (!t0) t0 = ahora;
        var u = clamp((ahora - t0) / DURACION, 0, 1);
        pintarPar(desde, idx, u);
        pintarTexto(desde, idx, u);
        if (relleno) {
          var a = n > 1 ? desde / (n - 1) : 1, b = n > 1 ? idx / (n - 1) : 1;
          relleno.style.height = ((a + (b - a) * u) * 100).toFixed(2) + '%';
        }
        if (u < 0.5) { /* el indicador cambia a mitad de camino */ }
        else marcarActivo(idx);
        if (u < 1) animacion = requestAnimationFrame(paso);
        else { animacion = null; fijar(idx); }
      })(0);
    }

    pines.forEach(function (b) {
      b.addEventListener('click', function () {
        irA(parseInt(b.getAttribute('data-np-fungi-pin'), 10) || 0);
      });
    });

    /* Teclado sobre la linea de tiempo, como manda el patron de
       pestanas: flechas para moverse, Inicio y Fin para los extremos. */
    raiz.addEventListener('keydown', function (ev) {
      if (!ev.target.closest || !ev.target.closest('[data-np-fungi-pin]')) return;
      var d = 0;
      if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') d = 1;
      else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') d = -1;
      else if (ev.key === 'Home') d = -n;
      else if (ev.key === 'End') d = n;
      else return;
      ev.preventDefault();
      var destino = clamp(actual + d, 0, n - 1);
      irA(destino);
      if (pines[destino]) pines[destino].focus();
    });

    /* Swipe en movil. Solo cuenta si el gesto es MAS HORIZONTAL QUE
       VERTICAL: si no, cualquier scroll con el dedo cambiaria de hongo. */
    var x0 = 0, y0 = 0, siguiendo = false;
    raiz.addEventListener('touchstart', function (ev) {
      if (ev.touches.length !== 1) return;
      x0 = ev.touches[0].clientX; y0 = ev.touches[0].clientY; siguiendo = true;
    }, { passive: true });

    raiz.addEventListener('touchend', function (ev) {
      if (!siguiendo) return;
      siguiendo = false;
      var t = ev.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      irA(clamp(actual + (dx < 0 ? 1 : -1), 0, n - 1));
    }, { passive: true });

    /* ----------------------------------------------------------------
       EN MOVIL, QUE LA ESCENA ENTRE EN LA PANTALLA.

       El contenedor fijo mide EXACTAMENTE `100svh` y recorta lo que se
       pasa (`overflow: hidden`, contenido centrado). Apilado a tamano
       de escritorio el contenido medio 973 px contra 664 de un iPhone
       con Safari, y se cortaba POR ARRIBA Y POR ABAJO a la vez: el
       titulo y los botones. Ningun telefono tiene 973 px de alto, asi
       que no era cosa de un modelo.

       SE PRUEBAN NIVELES DE COMPACTACION Y SE ELIGE EL PRIMERO QUE CABE.
       Cada nivel (`data-compacto` en la seccion, estilos en el bloque
       100 de `custom.css`) quita algo mas de lo secundario:

         0  todo                       2  sin descripcion
         1  sin etiqueta ni subtitulo   3  sin iconos

       NO HAY UMBRALES DE ALTO ESCRITOS: se mide el contenido real, con
       el texto y la fuente que haya. Una media query por alto no sirve
       en Safari de iPhone: la ventana cambia de alto al esconderse la
       barra de direcciones y las piezas aparecerian y desaparecerian a
       mitad del scroll. Aca se mide contra el `height: 100svh` del
       propio contenedor, que es el alto MINIMO y no se mueve.

       Se vuelve a medir en cada nivel porque `medir()` reserva el alto
       de la ficha mas alta, y esa cambia con lo que se oculta.

       ULTIMO RECURSO: si ni el nivel 3 cabe (pantalla muy baja o texto
       agrandado por accesibilidad) se escala el bloque con `zoom`, con
       piso en 0,6. Es preferible un poco mas chico a que se corte.

       En ESCRITORIO no se toca nada: el diseno de tres columnas cabe.
       ---------------------------------------------------------------- */
    var sticky = raiz.querySelector('.np-fungi__sticky');
    var grid   = raiz.querySelector('.np-fungi__grid');

    function usado() {
      var cs = window.getComputedStyle(sticky);
      return grid.offsetHeight + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    }

    function cabe() {
      // 4 px de aire: un contenido que roza el borde se ve apretado.
      return usado() <= sticky.clientHeight - 4;
    }

    function ajustarAlto() {
      if (!sticky || !grid) { medir(); return; }
      grid.style.zoom = '';

      if (mqEsc.matches) {
        raiz.removeAttribute('data-compacto');
        medir();
        return;
      }

      for (var nivel = 0; nivel <= 3; nivel++) {
        raiz.setAttribute('data-compacto', nivel);
        medir();
        if (cabe()) return;
      }

      var libre = sticky.clientHeight - 4;
      var f = clamp(libre / usado(), 0.6, 1);
      grid.style.zoom = f;
    }

    function acomodar() {
      ajustarAlto();
      actual = -1;
      pintar();
    }

    /* ----------------------------------------------------------------
       NO PINTAR MIENTRAS LA SECCION NO SE VE.

       `pintar()` corria en CADA cuadro de scroll de TODA la pagina,
       aunque la seccion estuviera a tres pantallas de distancia: leia la
       posicion y recorria las cinco fotos y las cinco fichas igual. Es
       trabajo tirado, y compite justo con el scroll que el cliente si
       esta mirando.

       NO SE PIERDE NINGUN CUADRO: el observador vuelve a pintar al
       entrar, asi que si se bajo rapido con la seccion afuera, al asomar
       se dibuja la posicion que corresponde. Es lo mismo que ya hacia
       `acomodar()` al cambiar el tamano de la ventana.

       Sin `IntersectionObserver` la bandera queda en `true` y se
       comporta como antes.
       ---------------------------------------------------------------- */
    var enPantalla = true;
    if ('IntersectionObserver' in window) {
      enPantalla = false;
      new IntersectionObserver(function (es) {
        enPantalla = es[0].isIntersecting;
        if (enPantalla) {
          pendiente = false;
          alScroll();
        }
      }, { rootMargin: '150px 0px' }).observe(raiz);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', acomodar, { passive: true });
    if (mqEsc.addEventListener) mqEsc.addEventListener('change', acomodar);
    if (mqRed.addEventListener) {
      mqRed.addEventListener('change', function (e) { reduce = e.matches; acomodar(); });
    }

    // Las fotos llegan despues del HTML y cambian el alto de la columna.
    raiz.querySelectorAll('img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', ajustarAlto, { once: true });
    });

    /* LAS FUENTES TAMBIEN CAMBIAN EL ALTO. Antes de que lleguen, el texto
       se reparte con la tipografia de respaldo y el nivel elegido puede
       quedar corto o de mas. Con Barlow Condensed y DM Sans las lineas se
       reparten distinto, asi que hay que volver a elegir cuando estan. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(acomodar);
    }

    /* ----------------------------------------------------------------
       PRECARGAR LAS CINCO MUESTRAS ANTES DE LLEGAR.

       Salen con `loading="lazy"`, asi que el navegador no las pide
       hasta tenerlas a la vista. Con el scroll mandando la escena eso
       se nota: al pasar a un hongo cuya foto todavia no llego, el disco
       sigue mostrando la anterior y la seccion PARECE TRABADA. Es la
       causa mas probable del "se queda pegado a veces" que reporto la
       clienta el 24 de octubre.

       Cuando la seccion esta a dos pantallas de distancia se les quita
       el diferido y se les pide `decode()`: asi llegan descomprimidas y
       el cambio no tiene que esperar a nada.

       EL COSTO ES BAJO AUNQUE LOS PNG PESEN 800 KB: el CDN de Shopify
       entrega WebP a cualquier navegador que lo acepte y a 760 px cada
       muestra son ~90 KB. Las cinco, ~450 KB, y recien cuando la
       seccion esta cerca.
       ---------------------------------------------------------------- */
    if ('IntersectionObserver' in window) {
      var cerca = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        cerca.disconnect();
        fotos.forEach(function (im) {
          im.loading = 'eager';
          if (im.decode) im.decode().catch(function () {});
        });
      }, { rootMargin: '200% 0px' });
      cerca.observe(raiz);
    }

    acomodar();
  }

  function init() {
    var nodos = document.querySelectorAll('[data-np-fungi]');
    for (var i = 0; i < nodos.length; i++) arrancar(nodos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // El editor redibuja la seccion al cambiar un ajuste
  document.addEventListener('shopify:section:load', init);
})();
